import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Form, Input, Modal, Row, Select, Switch } from "antd";
import styles from "./Durgsystem.module.css";
import {
  detailDurgsystem,
  saveDurgSystem,
  selectDetail,
  selectDurgId,
  setDetail,
  setSelectId,
} from "../durgsystem/durgsystemSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  durgSystemCategories,
  durgSystemCategoryName,
} from "../../models/durgSystem";
const { Option } = Select;
const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 20 },
};

export const DurgModal = (props: {
  visible: boolean;
  onOk: () => void;
  onCancel: () => void;
}) => {
  const inputRef = useRef<Input>(null)

  const [action, setAction] = useState("新增");

  const [title, setTitle] = useState("药房");

  const [form] = Form.useForm();

  const dispatch = useDispatch();

  const selectId = useSelector(selectDurgId);

  useEffect(() => {
    if (props?.visible) {
      if (selectId) {
        setAction("修改");
        dispatch(detailDurgsystem(selectId));
      } else {
        setAction("新增");
      }
    }
  }, [selectId, props?.visible]);

  const detail: any = useSelector(selectDetail);

  useEffect(() => {
    if (props?.visible) {
      if (JSON.stringify(detail) !== "{}") {
        setAction("修改");
        form.setFieldsValue({
          name: detail.name,
          category: detail.category,
          deliveryMethod: detail.deliveryMethod,
          servicePurchaseStorage: Boolean(detail.servicePurchaseStorage),
          serviceShopPrice: Boolean(detail.serviceShopPrice),
        });
      } else {
        setAction("新增");
        form.setFieldsValue({
          category: 0,
          servicePurchaseStorage: 1,
          serviceShopPrice: 1,
          deliveryMethod: 0
        });
      }
    }
  }, [detail,props?.visible]);

  useEffect(() => {
    if (props.visible && !selectId) {
      // 添加一个小延迟，确保DOM元素已经完全渲染后再调用focus
      setTimeout(() => {
        inputRef.current?.focus()
      }, 100)
    }
  }, [props.visible, selectId])

  return (
    <div>
      <Modal
        title={action + title}
        visible={props.visible}
        okText="确认"
        cancelText="取消"
        className={styles.form}
        onOk={() => {
          props.onOk();
        }}
        onCancel={() => {
          form.resetFields();
          dispatch(setSelectId(0));
          dispatch(setDetail({}));
          props.onCancel();
        }}
        footer={null}
      >
        <Form
          {...layout}
          form={form}
          name="basic"
          autoComplete="off"
          initialValues={{ remember: true }}
          onFinish={(vs) => {
            if (detail) {
              dispatch(
                saveDurgSystem({
                  ...vs,
                  servicePurchaseStorage: vs.servicePurchaseStorage
                    ? Number(vs.servicePurchaseStorage)
                    : 0,
                  serviceShopPrice: vs.serviceShopPrice
                    ? Number(vs.serviceShopPrice)
                    : 0,
                  id: detail.id,
                 
                })
                
              );
            } else {
              dispatch(
                saveDurgSystem({
                  ...vs,
                  servicePurchaseStorage: Number(vs.servicePurchaseStorage),
                  serviceShopPrice: Number(vs.serviceShopPrice),
                })
              );
            }
            form.resetFields();
            dispatch(setSelectId(0));
            dispatch(setDetail({}));
            props.onOk();
          }}
        >
          <Row gutter={20}>
            <Col span={24} style={{ height: "50px" }}>
              <Form.Item
                label="药房名称"
                name="name"
                rules={[
                  {
                    required: true,
                    message: "请输入药房名称",
                  },
                  {
                    max: 100,
                    message: "药房名称最长100个字符",
                  },
                ]}
              >
                <Input ref={inputRef} />
              </Form.Item>
            </Col>
            <Col span={24} style={{ height: "50px" }}>
              <Form.Item label="药房类别" name="category">
                <Select>
                  {durgSystemCategories.map((v) => {
                    return (
                      <Option value={v} key={v}>
                        {durgSystemCategoryName(v)}
                      </Option>
                    );
                  })}
                </Select>
              </Form.Item>
            </Col>

            {/* <Col span={24} style={{ height: "50px" }}>
              <Form.Item label="出库方式" name="deliveryMethod">
                <Select>
                  <Option value={0}>最短有效期</Option>
                  <Option value={1}>最少库存</Option>
                </Select>
              </Form.Item>
            </Col> */}
            <Col span={12}>
              <Form.Item
                label="售药权限"
                name="serviceShopPrice"
                valuePropName="checked"
                labelCol={{ span: "12" }}
                wrapperCol={{ span: "12" }}
                style={{ float: "left" }}
              >
                <Switch checkedChildren="开启" unCheckedChildren="关闭" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="购入入库权限"
                name="servicePurchaseStorage"
                valuePropName="checked"
                labelCol={{ span: "15" }}
                wrapperCol={{ span: "9" }}
                style={{ float: "left" }}
              >
                <Switch checkedChildren="开启" unCheckedChildren="关闭" />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Button
                style={{ float: "right" }}
                onClick={() => {
                  form.resetFields();
                  dispatch(setSelectId(0));
                  dispatch(setDetail({}));
                  props.onCancel();
                }}
              >
                取消
              </Button>
            </Col>
            <Col span={12}>
              <Button
                htmlType="submit"
                type="primary"
                style={{ float: "left" }}
              >
                确认
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </div>
  );
};
